/* 
  A note after migrating to Vite:
  There is an issue with 'import.meta.env' in Jest environment.
  We cannot use 'import.meta.env' in Jest directly because it is not defined in Jest environment.
  So we split all of the env vars into one single file, then mock it in jest test setup file.
  
  IMPORTANT: If you plan to:
    - rename this variable
    - or addding any env vars
  Make sure to update the jest test setup file as well. Or else the tests will fail with false negative alerts!
*/
export const ENV_VARS = {
  VITE_APP_BUILD_ENV: import.meta.env.VITE_APP_BUILD_ENV,
  NODE_ENV: import.meta.env.NODE_ENV,
};
